import React from 'react'
import { useField, FieldHookConfig } from 'formik'

import Switch, { SwitchProps } from '@mui/material/Switch'

type SwitchFieldProps = FieldHookConfig<boolean> & SwitchProps

export default function SwitchField(props: SwitchFieldProps) {
  const [field] = useField<boolean>(props)

  return (
    <Switch
      {...props}
      onBlur={field.onBlur}
      onChange={!props.readOnly ? field.onChange : undefined}
      checked={field.value}
    />
  )
}
